export default __webpack_public_path__ + "static/media/portable.92196236.jpg";